import { main } from 'boot'
import { TYPE }  from 'network/network_api';

import SETTINGS from 'settings'
import MainScene from './mainscene';
import minigame_client from 'minigame_client/minigame_client'
import { MinigameMath21 } from "src/library/minigame_client/twentyone/MinigameMath21"

// DESKTOP_HORIZONTAL
import { configUiPanel_desktop_horizontal } from "../cfg/desktop_horizontal/panel"
import { configUiMenu_desktop_horizontal } from "../cfg/desktop_horizontal/menu"
import { resources_desktop_horizontal } from "../res/desktop_horizontal/resources"
import { configGame_desktop_horizontal } from "../cfg/desktop_horizontal/game"

// MOBILE_VERTICAL
import { configUiPanel_mobile_vertical } from "../cfg/mobile_vertical/panel"
import { configUiMenu_mobile_vertical } from "../cfg/mobile_vertical/menu"
import { resources_mobile_vertical } from "../res/mobile_vertical/resources"
import { configGame_mobile_vertical } from "../cfg/mobile_vertical/game"

// MOBILE_HORIZONTAL
import { configUiPanel_mobile_horizontal } from "../cfg/mobile_horizontal/panel"
import { configUiMenu_mobile_horizontal } from "../cfg/mobile_horizontal/menu"
import { resources_mobile_horizontal } from "../res/mobile_horizontal/resources"
import { configGame_mobile_horizontal } from "../cfg/mobile_horizontal/game"

let DEBUG_NO_NEED_SERVER = false;

SETTINGS.preserve_resource_format_for_all = true;

// hide ui panel
SETTINGS.ui_config = {};

SETTINGS.no_default_lib = true;

//отключить рендер графики и тики обновления игры когда вкладка игры становится невидимой:
SETTINGS.power_savings = true;

//разрешить девайсу уходить в спящий режим с открытой игрой:
SETTINGS.enable_sleep = true;

SETTINGS.isUseScreenConfigForAdaptiveContainerScale = true;

SETTINGS.no_iOS_fullscreen = true;

// SETTINGS.lock_portrait = !screen.isPC;

SETTINGS.ears_additional_res = [
    'res/lib/ears/0/left_ear.png',
    'res/lib/ears/0/right_ear.png',
    'res/lib/ears/1/left_ear.png',
    'res/lib/ears/1/right_ear.png',
    'res/lib/ears/2/left_ear.png',
    'res/lib/ears/2/right_ear.png',
    'res/lib/ears/3/left_ear.png',
    'res/lib/ears/3/right_ear.png',
    'res/lib/ears/4/left_ear.png',
    'res/lib/ears/4/right_ear.png',
    'res/lib/ears/5/left_ear.png',
    'res/lib/ears/5/right_ear.png'
];

function getOrientation() {
    // return window.orientation === 0 || window.orientation === 180 ? 'portrait' : 'landscape';
    return window.innerWidth < window.innerHeight ? 'portrait' : 'landscape';
}

const MODE = {
    DESKTOP_HORIZONTAL: 0,
    MOBILE_VERTICAL: 1,
    MOBILE_HORIZONTAL: 2,
    MOBILE_TWO_SCREEN: 3,
};

let CURRENT_MODE = MODE.DESKTOP_HORIZONTAL;

let modeURL = null;
if (SETTINGS.url_params['gamecustommode'] !== undefined)    modeURL = decodeURIComponent(SETTINGS.url_params['gamecustommode']);
if (SETTINGS.url_params['mode'] !== undefined)              modeURL = decodeURIComponent(SETTINGS.url_params['mode']);
if (SETTINGS.url_params['type'] !== undefined)              modeURL = decodeURIComponent(SETTINGS.url_params['type']); // для сайта нард
if (modeURL) {
    switch (modeURL) {
        case 'desktop_frame':       CURRENT_MODE = MODE.DESKTOP_HORIZONTAL; break;
        case 'desktop_frame_wide':  CURRENT_MODE = MODE.DESKTOP_HORIZONTAL; break;
        case 'desktop_full':        CURRENT_MODE = MODE.DESKTOP_HORIZONTAL; break;
        case 'mobile_vertical':     CURRENT_MODE = MODE.MOBILE_VERTICAL;    break;
        case 'mobile_horisontal':   CURRENT_MODE = MODE.MOBILE_HORIZONTAL;  break;  // опечатка на сайте ивана
        case 'mobile_horizontal':   CURRENT_MODE = MODE.MOBILE_HORIZONTAL;  break;
        case 'mobile_auto':         CURRENT_MODE = MODE.MOBILE_TWO_SCREEN;  break;
    }
}

// в айфоне нет полноэкранного режима и поэтому нет возможности залочить экран
if (CURRENT_MODE === MODE.MOBILE_VERTICAL || CURRENT_MODE === MODE.MOBILE_HORIZONTAL) {
    const runInIOS = ( !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) );
    if (runInIOS)
        CURRENT_MODE = MODE.MOBILE_TWO_SCREEN;
}

function getConfigs (mode) {
    let configUiMenu    = {};
    let configUiPanel   = {};
    let configGame      = {};

    switch (mode) {

        case MODE.DESKTOP_HORIZONTAL:
            configUiMenu    = configUiMenu_desktop_horizontal;
            configUiPanel   = configUiPanel_desktop_horizontal;
            configGame      = configGame_desktop_horizontal;
            break;

        case MODE.MOBILE_VERTICAL:
            configUiMenu    = configUiMenu_mobile_vertical;
            configUiPanel   = configUiPanel_mobile_vertical;
            configGame      = configGame_mobile_vertical;
            break;

        case MODE.MOBILE_HORIZONTAL:
            configUiMenu    = configUiMenu_mobile_horizontal;
            configUiPanel   = configUiPanel_mobile_horizontal;
            configGame      = configGame_mobile_horizontal;
            break;

        case MODE.MOBILE_TWO_SCREEN:
            if (getOrientation() === 'landscape') {
                configUiMenu    = configUiMenu_mobile_horizontal;
                configUiPanel   = configUiPanel_mobile_horizontal;
                configGame      = configGame_mobile_horizontal;
            }
            else {
                configUiMenu    = configUiMenu_mobile_vertical;
                configUiPanel   = configUiPanel_mobile_vertical;
                configGame      = configGame_mobile_vertical;
            }
            break;

        default:
            configUiMenu    = configUiMenu_desktop_horizontal;
            configUiPanel   = configUiPanel_desktop_horizontal;
            configGame      = configGame_desktop_horizontal;
            break;
    }

    return {game: configGame, menu: configUiMenu, panel: configUiPanel};
}

function getResources (mode) {
    let resources = [];

    switch (mode) {

        case MODE.DESKTOP_HORIZONTAL:
            resources.push(configUiPanel_desktop_horizontal.resources);
            resources.push(configUiMenu_desktop_horizontal.resources);
            resources.push(resources_desktop_horizontal);
            break;

        case MODE.MOBILE_VERTICAL:
            resources.push(configUiPanel_mobile_vertical.resources);
            resources.push(configUiMenu_mobile_vertical.resources);
            resources.push(resources_mobile_vertical);
            break;

        case MODE.MOBILE_HORIZONTAL:
            resources.push(configUiPanel_mobile_horizontal.resources);
            resources.push(configUiMenu_mobile_horizontal.resources);
            resources.push(resources_mobile_horizontal);
            resources.push(resources_mobile_vertical);          // почти все ресы взяты из вертикальной версии
            break;

        case MODE.MOBILE_TWO_SCREEN:
            resources.push(configUiPanel_mobile_vertical.resources);
            resources.push(configUiMenu_mobile_vertical.resources);
            resources.push(resources_mobile_vertical);

            resources.push(configUiPanel_mobile_horizontal.resources);
            resources.push(configUiMenu_mobile_horizontal.resources);
            resources.push(resources_mobile_horizontal);
            break;

        default:
            resources.push(configUiPanel_desktop_horizontal.resources);
            resources.push(configUiMenu_desktop_horizontal.resources);
            resources.push(resources_desktop_horizontal);
            break;
    }

    return resources;
}


// TODO: uncomment for set screen mode or run without server
// CURRENT_MODE = MODE.MOBILE_TWO_SCREEN;
// DEBUG_NO_NEED_SERVER = true;



SETTINGS.lock_portrait = CURRENT_MODE === MODE.MOBILE_VERTICAL;

if (CURRENT_MODE !== MODE.DESKTOP_HORIZONTAL) {
    //relief mobile battery:
    SETTINGS.skip_frames = 2;

    // disable ears
    SETTINGS.no_ears = true;
    SETTINGS.transparent_render = true;
}


// entry point
main({
    //открыли страницу с игрой:
    on_space : s => {
        if (!DEBUG_NO_NEED_SERVER) {
            minigame_client(s, MinigameMath21);
        }
        else {
            s.s('server_initialized').next(true);
            s.s('net').next(true);
            s.s('balance_poll').next(true);
        }
    },
    //игра загрузилась: эта функция будет вызываться многократно и game_space каждый раз будет чистеньким новым:
    reactive : ( game_space, c, app ) => {
        const container = app.gameContainer;

        const cfg = getConfigs(CURRENT_MODE);

        // you can attempt locking orientation ONLY when it's in fullscreen:
        // что бы залочит экран даже в портретной ориентации нужно выставить landscape в true из-за этого условия в boot: if ( landscape && is_fullscreen() )
        // в айфоне, я так понимаю, нет полноэкранного режима и поэтому там нельзя залочить экран?
        window.space.s( 'landscape' ).next(CURRENT_MODE !== MODE.MOBILE_TWO_SCREEN);

        let mainScene = new MainScene(game_space, cfg.game, cfg.menu, cfg.panel);
        container.addChild( mainScene );

        if (CURRENT_MODE === MODE.MOBILE_TWO_SCREEN) {
            let configGame = cfg.game;

            // смена экрана под текущий конфиг
            {
                // window.space.s( 'landscape' ).next(false);
                window.space.s('need_resize').next(true);
                window.space.s('screen_config').next(configGame.Screen);
                game_space.s('screen_ratio').next(configGame.Screen.screen_ratio);
            }

            // отслеживание ориентации экрана
            game_space.s('change_screen')
                .on(() => {
                    if (getOrientation() === 'portrait' && configGame.Screen.resolution.width > configGame.Screen.resolution.height ||
                        getOrientation() === 'landscape' && configGame.Screen.resolution.width < configGame.Screen.resolution.height) {
                        // reinitialize - загрузится игра с соответствующими экрану конфигами
                        window.space.s('child_init' ).next();
                    }
                });
        }

        if (!DEBUG_NO_NEED_SERVER) {
            game_space.s('account_selection_changed')
                .on(data => mainScene.onAccountSelectionChanged(data));

            game_space.s('net')
                .filter(data => data)
                .on(data => mainScene.onModelChanged(data));

            game_space.s('balance_poll')
                .filter(p => p)
                .on(p => mainScene.onAccountChanged(p));
        }


        // можно одновременно запустить несколько режимов(не забыть ресурсы для них добавить в resources_config)
        // {
        //     const cfg2 = getConfigs(MODE.MOBILE_VERTICAL);
        //
        //     let mainScene2 = new MainScene(game_space, cfg2.game, cfg2.menu, cfg2.panel);
        //     container.addChild(mainScene2);
        //
        //     game_space.s('account_selection_changed')
        //         .on(data => mainScene2.onAccountSelectionChanged(data));
        //
        //     game_space.s('net')
        //         .filter(data => data)
        //         .on(data => mainScene2.onModelChanged(data));
        //
        //     game_space.s('balance_poll')
        //         .filter(p => p)
        //         .on(p => mainScene2.onAccountChanged(p));
        // }
    },
    resources_config : getResources(CURRENT_MODE),
    screen_config : getConfigs(CURRENT_MODE).game.Screen
});




// WEBPACK FOOTER //
// ./src/main.es6